import './frontend.scss';
import { initBlocks } from './initBlocks';

document.addEventListener( 'DOMContentLoaded', () => {
	initBlocks();
} );